import React, { useState, useEffect } from 'react';
import LeaderboardWidget from './LeaderboardWidget';
import CollaborationCarousel from './CollaborationCarousel';
import { getWeeklyLeaderboard } from '@/services/leaderboardService';
import { LeaderboardUser } from '@/types/leaderboard';
import { Skeleton } from './ui/skeleton';

const RightSidebar = () => {
  const [leaderboardUsers, setLeaderboardUsers] = useState<LeaderboardUser[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        setIsLoading(true);
        const data = await getWeeklyLeaderboard();
        setLeaderboardUsers(data);
      } catch (error) {
        console.error('Error fetching leaderboard data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeaderboardData();
  }, []);

  return (
    <div className="hidden lg:block w-80 min-w-[320px] h-screen overflow-y-auto sticky top-0 border-l-4 border-black bg-vibebops-card">
      <div className="p-3">
        <CollaborationCarousel />
        
        <div className="pt-3">
          {isLoading ? (
            <div className="space-y-3 vibebops-card p-4">
              <div className="flex items-center justify-between">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-4 w-16" />
              </div>
              <div className="space-y-2">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Skeleton key={i} className="h-14 w-full" />
                ))}
              </div>
            </div>
          ) : (
            <LeaderboardWidget users={leaderboardUsers} />
          )}
        </div>
      </div>
    </div>
  );
};

export default RightSidebar;
